import { render, staticRenderFns } from "./EditBox.vue?vue&type=template&id=1b1ba2be&scoped=true&"
import script from "./EditBox.vue?vue&type=script&lang=js&"
export * from "./EditBox.vue?vue&type=script&lang=js&"
import style0 from "./EditBox.vue?vue&type=style&index=0&id=1b1ba2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ba2be",
  null
  
)

export default component.exports